import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import version from '@/api/version'

const configureSentry = (app: App): void => {
  if (import.meta.env.DEV) {
    // disable Sentry in dev mode
    return
  }
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_CLIENT_SENTRY_DSN,
    release: version,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    attachStacktrace: true,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    normalizeDepth: 4,
  })
  Sentry.attachErrorHandler(app, {
    attachProps: true,
    attachErrorHandler: true,
  })
}

export { configureSentry, Sentry }
